export class Config {
    mileage_rate: number
    distance_threshold: number
    
    constructor() {    
    }
  
    static buildOne(obj: any): Config {
      let target: Config = Object.assign(new Config(), obj)
      return target
    }
  
    static buildMany(objs: any[]): Config[] {
      const lobjs = []
      for (const i in objs) {
        if (objs.hasOwnProperty(i)) {
          lobjs.push(Config.buildOne(objs[i]))
        }
      }
      return lobjs
    }
  }
  
  